import React, { useContext } from "react";
import { ChevronRight } from "lucide-react";
import { WorkoutContext } from "../../contexts/WorkoutContext";
import { formLabel } from "../../utils/trainingLoad";

const Stat = ({ label, value, note }) => (
  <div className="grid min-w-0 gap-0.5">
    <span className="text-[10px] uppercase tracking-wide text-muted-foreground">{label}</span>
    <span className="text-lg font-semibold tabular-nums text-foreground">{value}</span>
    {note && <span className="truncate text-[11px] text-muted-foreground">{note}</span>}
  </div>
);

/**
 * Activity's way into the Progress page (#203): up to three headline figures
 * (fitness, VO2max, FTP) and "See progress". The charts live on the page, so
 * Activity stays a quick look at your week.
 */
const ProgressSummaryCard = ({ fitness, vo2max, ftp }) => {
  const { setView } = useContext(WorkoutContext);
  const stats = [];
  if (fitness) {
    const change = Math.round((fitness.fitness - fitness.fitnessWeekAgo) * 7);
    stats.push(
      <Stat
        key="fitness"
        label="Fitness"
        value={Math.round(fitness.fitness * 7).toLocaleString("en-AU")}
        note={`${change > 0 ? "+" : change < 0 ? "−" : "±"}${Math.abs(change)} this week`}
      />,
    );
  }
  if (vo2max?.headline) stats.push(<Stat key="vo2" label="VO2max" value={vo2max.headline} note="ml/kg/min" />);
  if (ftp) {
    stats.push(
      <Stat
        key="ftp"
        label="FTP"
        value={`${ftp.watts} W`}
        note={ftp.change ? `${ftp.change > 0 ? "+" : "−"}${Math.abs(ftp.change)} W in 30 days` : "Bike"}
      />,
    );
  }
  return (
    <button
      type="button"
      onClick={() => setView("progress")}
      className="grid gap-3 rounded-2xl border border-border bg-card p-3.5 text-left"
    >
      <span className="flex items-center justify-between gap-2">
        <span className="text-[15px] font-bold text-white">Progress</span>
        {fitness && (
          <span className="rounded-full border border-border px-1.5 text-[10px] font-semibold leading-4 text-foreground/80">
            {formLabel(fitness.formPct)}
          </span>
        )}
      </span>
      {stats.length > 0 ? (
        <span className="grid grid-cols-3 gap-2">{stats}</span>
      ) : (
        <span className="text-xs text-muted-foreground">Training load by week, and more as you train.</span>
      )}
      <span className="flex items-center justify-between border-t border-border pt-2 text-xs font-semibold text-foreground">
        See progress
        <ChevronRight className="h-4 w-4 text-muted-foreground" />
      </span>
    </button>
  );
};

export default ProgressSummaryCard;
